import { render, staticRenderFns } from "./AppointmentScheduler.vue?vue&type=template&id=631f8336&"
import script from "./AppointmentScheduler.vue?vue&type=script&lang=ts&"
export * from "./AppointmentScheduler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports